
<div class="edit-page-root-container system-settings-edit-root-container">
  <div class="page-content">
    <div class="page-header">
      <button mat-button class="nav-button">
        <img src="assets/images/menu/svg/display-order.svg" style="width: 24px;">
      </button>
      <div class="title">
        Hot Item Display Order
      </div>
      <div class="action-btn-container">
        <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>

        <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
      </div>
    </div>
    <div class="page-details">
      <div class="detail-section general-settings">
        <form class="edit-form" *ngIf="itemClassForm" [formGroup]="itemClassForm">
          <div class="content-container">

            <div class="input-group">
              <mat-form-field style="width: 100%;">
                <input matInput type="text" placeholder="Select Hot Items" formControlName="hot_item"
                  [matAutocomplete]="menuDeptAuto" (input)="filterMenuDepartments()" (focus)="filterMenuDepartments()">
                <button *ngIf="menuDepartmentControl.value" (click)="clearMenuDepartment()" matSuffix mat-icon-button
                  aria-label="Clear">
                  <mat-icon style="color: rgb(29 28 28 / 38%); font-weight: 500; font-size: 22px;">close</mat-icon>
                </button>
                <mat-autocomplete [displayWith]="displayMenuDepartmentName" #menuDeptAuto="matAutocomplete">
                  <mat-option *ngFor="let dept of filteredMenuDepartments" [value]="dept">
                    <span>{{dept.name}}</span>
                  </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="menuDepartmentControl.hasError('required')">
                  Please select a hot item.
                </mat-error>
                <mat-error *ngIf="menuDepartmentControl.hasError('invalidHotItem')">
                  Please select a valid hot item from the list.
                </mat-error>
              </mat-form-field>


              <br />
              <div cdkDropList cdkDropListOrientation="mixed" class="grid" (cdkDropListDropped)="drop($event)">
                <!-- @for (row of itemSubClasses; track row[0]) { -->
                @for (item of itemSubClasses; track item.sale_item_id) {
                <div class="item-cell" cdkDrag
                  [ngStyle]="{'background-color': item?.bg_color,'color': item?.fg_color, 'width': 'calc((100% / ' + numberOfColumns + ') - 10px)'}">
                  <div class="item-code">{{ item.code }}</div>
                  <div class="item-name">{{ item.name }}</div>
                </div>
                }
                <!-- } -->
              </div>
            </div>
            <!-- </div> -->

          </div>
        </form>
      </div>
    </div>
  </div>